type ConfirmationRecord = {
  adopted: boolean;
  authorName: string;
};

export function deriveManifestItemAdopter(
  item: { confirmations?: Record<number, ConfirmationRecord> },
  jobId?: number,
): { name: string } | undefined {
  if (jobId != null && item.confirmations?.[jobId]?.adopted) {
    return { name: item.confirmations[jobId].authorName };
  }
  const confirmations = item.confirmations
    ? Object.values(item.confirmations)
    : [];
  const adopted = confirmations.find(x => x.adopted);
  return adopted == null ? undefined : { name: adopted.authorName };
}
